export const normalizePhoneNumber = (number?: string) => {
	if (!number) return;
	let str = number.replace(/[^0-9.]/g, "");
	if (Number(str[0]) === 0) {
		str = str.slice(1);
		str = "62" + str;
	}

	return str;
};
